import React from 'react'
import { getAllCategories } from "../../api/category.api";
import { showError } from "../../services/toastServices";
import { AuthData } from '../Authorization/AuthWrapper';
import { useEffect, useState } from 'react';
import ProjectCardComponent from '../../components/Project/ProjectCardComponent';
import { isProjectFinished } from '../../services/EnumsService';

const HomePage = (props) => {
  const { user,logoutRefresh } = AuthData();
  const[categories, SetCategories] = useState([])
   
  useEffect(() => {
      async function loadCategories() {
          if(user.isAuthenticated){
              await getAllCategories(successGetCategories, errorGetCategories);
          }
      }
      loadCategories();
  }, [user])

  const successGetCategories = ((response)=>{
      SetCategories(response.data.items);
  })
  const errorGetCategories = ((error)=>{
      showError('Error al cargar categorías')
  })

  const renderCategories = categories
    .filter((category) => category.projects.some((project) => project.deadlineStatus >= 0 && !isProjectFinished(project)))
    .map((category) => {
        return (
            <div key={`hp-ct-${category.id}`} className="mb-6">
                {/* Header de categoría (opcional) */}
                <div className="font-bold text-lg mb-2 w-full">{category.name}</div>
                
                {/* Proyectos de esta categoría */}
                {/* <div className="grid grid-cols-3 border-black border- ml-2 bg-green-500"> */}
                <div className="flex flex-row rounded-lg m-2 bg-white">
                
                  {category.projects
                  .sort((a,b) => b.deadlineStatus - a.deadlineStatus)
                  .map((project) => {
                      if(isProjectFinished(project)) return null;
                      return (
                      <ProjectCardComponent
                          key={`hp-pj-${project.id}`}
                          project={project}
                          categoryId={category.id}
                          className="mb-3"
                      />
                      );
                  })}
                </div>
            </div>
        );
    });    
    const renderLoggedOutUser = (()=>{
        return(
            <div className="text-red-400 font-bold">No ha iniciado sesión.</div>
        )
    })

  return (
  <div className="mainContainer">
    <div className='flex flex-col '>
      <div className=''>
        {user.isAuthenticated ? renderCategories:renderLoggedOutUser()}
      </div>
    </div>
  </div>
)
}

export default HomePage